import RoleTag from '../RoleTag';

interface PreviewProps {
  name: string;
  color: string;
  description?: string;
}

const Preview = ({ name, color, description }: PreviewProps) => {
  return (
    <div className="mt-6 rounded border border-stroke-base-default bg-background-base-surface-3 bg-opacity-[16%] p-4">
      <p className=" font-bold text-content-base-subdued">Preview:</p>
      {(!!color?.length || color == null) && !!name?.length && (
        <div className="mt-0.5 flex items-center gap-4">
          <div className="self-start">
            <RoleTag name={name} color={color} />
          </div>
          <p className="text-sm font-[700] text-content-base-subdued">
            {description}
          </p>
        </div>
      )}
    </div>
  );
};

export default Preview;
